// Mesh and material factories shared by every builder.
import * as THREE from 'three';
import { mergeVertices } from 'three/addons/utils/BufferGeometryUtils.js';
import { scene } from '../core/scene.js';

// ---------- helpers ----------
export const M = (c, o = {}) =>
  new THREE.MeshStandardMaterial(
    Object.assign({ color: c, roughness: 0.9, flatShading: true, envMapIntensity: 0.5 }, o),
  );
// polished, smooth-shaded material with reflections (vehicles, water, glass)
export const P = (c, o = {}) =>
  new THREE.MeshStandardMaterial(
    Object.assign({ color: c, roughness: 0.35, metalness: 0.3, envMapIntensity: 1 }, o),
  );
// weld vertices and recompute normals so bevelled shapes shade as smooth curved surfaces
export function smooth(g) {
  g.deleteAttribute('normal');
  g.deleteAttribute('uv');
  g = mergeVertices(g, 1e-3);
  g.computeVertexNormals();
  return g;
}
export function add(geo, mat, x = 0, y = 0, z = 0, parent = scene) {
  const m = new THREE.Mesh(geo, mat);
  m.position.set(x, y, z);
  m.castShadow = m.receiveShadow = true;
  parent.add(m);
  return m;
}
export function canvasTex(w, h, draw) {
  const c = document.createElement('canvas');
  c.width = w;
  c.height = h;
  draw(c.getContext('2d'));
  const t = new THREE.CanvasTexture(c);
  t.colorSpace = THREE.SRGBColorSpace;
  t.wrapS = t.wrapT = THREE.RepeatWrapping;
  t.anisotropy = 8;
  return t;
}
export const Ph = (c, o = {}) =>
  new THREE.MeshPhysicalMaterial(
    Object.assign(
      {
        color: c,
        roughness: 0.3,
        metalness: 0.5,
        clearcoat: 1,
        clearcoatRoughness: 0.06,
        envMapIntensity: 1,
      },
      o,
    ),
  );
